"use client";

import { useEffect, useState } from "react";

type UseOneTimeNotificationResult = {
  shouldShow: boolean;
  isLoading: boolean;
  error?: Error;
};

export function useOneTimeNotification(tag: string | undefined): UseOneTimeNotificationResult {
  const [shouldShow, setShouldShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    let isMounted = true;
    if (!tag) return;
    setIsLoading(true);
    fetch(`/api/notification-log/${encodeURIComponent(tag)}`, { method: "POST" })
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to check notification status");
        return res.json();
      })
      .then((data: { exists: boolean }) => {
        if (!isMounted) return;
        setShouldShow(!data.exists);
      })
      .catch((e: any) => {
        if (!isMounted) return;
        setError(e instanceof Error ? e : new Error(String(e)));
        // Fail-closed: don't show popup on error
        setShouldShow(false);
      })
      .finally(() => {
        if (!isMounted) return;
        setIsLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [tag]);

  return { shouldShow, isLoading, error };
}


